import { injectable } from 'inversify';
import type { ApiDataTransformer } from '@kiplin/web-common/architecture-core';
import type { CustomerChatbotVisitorIdentificationApiData } from '@client/feature/customer-chatbots/data/api-data/customer-chatbot-visitor-identification.api-data';
import type { CustomerChatbotVisitorIdentification } from '@client/feature/customer-chatbots/domain/type/customer-chatbot-visitor-identification.type';

@injectable()
export class CustomerChatbotVisitorIdentificationApiDataTransformer implements ApiDataTransformer<
  CustomerChatbotVisitorIdentificationApiData,
  CustomerChatbotVisitorIdentification
> {
  public map(data: CustomerChatbotVisitorIdentificationApiData): CustomerChatbotVisitorIdentification {
    return {
      email: data.email,
      token: data.token,
    };
  }
}
